import { EmailFlowActionTypes } from "./types";

export function setPinCheckError() {
  return {
    type: EmailFlowActionTypes.SET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW,
  };
}

export function resetPinCheckError() {
  return {
    type: EmailFlowActionTypes.RESET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW,
  };
}

/*
 * Actions to change the isLoading state
 */
export function setLoadingEmailFlow() {
  return {
    type: EmailFlowActionTypes.SET_BTN_LOADING,
  };
}
export function cleanLoadingEmailFlow() {
  return {
    type: EmailFlowActionTypes.CLEAN_BTN_LOADING,
  };
}

export function setEmailsForSendPin(data: []) {
  return {
    type: EmailFlowActionTypes.SET_EMAILS_FOR_EMAIL_FLOW,
    payload: data,
  };
}

export function getEmailsForSendPin(id: string) {
  return {
    type: EmailFlowActionTypes.GET_EMAILS_FOR_EMAIL_FLOW,
    payload: { id },
  };
}

export function verifyPin(pin: string, sessionId: string) {
  return {
    type: EmailFlowActionTypes.VERIFY_PIN_EMAIL_FLOW,
    payload: { pin, sessionId },
  };
}

export function goToVerifyPinEmailFlow(id: string) {
  return {
    type: EmailFlowActionTypes.GO_TO_VERIFY_PIN_EMAIL_FLOW,
    payload: id,
  };
}

export function goBackToSecondStepEmailFlow(id: string) {
  return {
    type: EmailFlowActionTypes.GO_BACK_TO_SECOND_STEP_EMAIL_FLOW,
    payload: id,
  };
}

export function sendSmsForEmailFlow(sessionId: string, maskedPhone: string) {
  return {
    type: EmailFlowActionTypes.SEND_SMS_FOR_EMAIL_FLOW,
    payload: { sessionId, maskedPhone },
  };
}

export function sendEmailForEmailFlow(
  emailId: string,
  sessionId: string,
  email: string
) {
  return {
    type: EmailFlowActionTypes.SEND_EMAIL_FOR_EMAIL_FLOW,
    payload: { emailId, sessionId, email },
  };
}

export function backToFirstEmailFlow(id: string, email: string) {
  return {
    type: EmailFlowActionTypes.BACK_TO_FIRST_STEP_EMAIL_FLOW,
    payload: { id, email },
  };
}

export function cancelSessionEmailFlow(payload: string) {
  return {
    type: EmailFlowActionTypes.CANCEL_SESSION_EMAIL_FLOW,
    payload,
  };
}

export function setEmailSources(sources: string[], contactValue: string) {
  return {
    type: EmailFlowActionTypes.SET_SOURCES,
    payload: { sources, contactValue },
  };
}

export function confirmEmailSource(session: string, source: string) {
  return {
    type: EmailFlowActionTypes.CONFIRM_SOURCES,
    payload: { sessionId: session, sessionSource: source },
  };
}

export function getEmailSources(payload: string) {
  return {
    type: EmailFlowActionTypes.GET_SOURCES,
    payload,
  };
}
